export const todayPointLists = [
  {
    label: '클릭뷰업',
    value: 'click',
  },
  {
    label: '포스팅 뷰업',
    value: 'post',
  },
  {
    label: '보너스뷰업 [자동적립]',
    value: 'auto',
  },
  {
    label: '보너스뷰업 [뷰플]',
    value: 'plus',
  },
];
